import * as React from 'react'
import { useSearchParams } from 'react-router'

function useSearchParamsWithUpdate() {
  const [searchParams, setSearchParams] = useSearchParams()

  return [searchParams, setSearchParams]
}

export function useResourcesParams() {
  const [urlSearchParams, setUrlSearchParams] = useSearchParamsWithUpdate()

  const [paramString, setParamString] = React.useState(
    urlSearchParams.toString(),
  )

  const lockParamString = React.useCallback(() => {
    setParamString(urlSearchParams.toString())
  }, [urlSearchParams])

  return {
    urlSearchParams,
    setUrlSearchParams,
    paramString,
    lockParamString,
  }
}
